import React from "react";
import { Cpu, ChartPieSlice, Heartbeat, ArrowUpRight } from "@phosphor-icons/react";
import { useI18n } from "../../i18n/I18nContext";

const ICONS = {
  "case-hetero": Cpu,
  "case-finops": ChartPieSlice,
  "case-integration": Heartbeat,
};

export const UseCases = () => {
  const { t } = useI18n();

  return (
    <section id="cases" data-testid="cases-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-8 mb-14">
          <div className="lg:col-span-7">
            <div className="mono text-xs uppercase tracking-[0.22em] text-brand-cyan mb-3">
              {t.useCases.sectionNum}
            </div>
            <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
              {t.useCases.headlinePart1}
              <br />
              <span className="text-muted">{t.useCases.headlinePart2}</span>
            </h2>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {t.useCases.cases.map((c) => {
            const Icon = ICONS[c.id] || Cpu;
            return (
              <div
                key={c.id}
                data-testid={c.id}
                className="group glass rounded-2xl p-8 relative overflow-hidden hover:-translate-y-1 transition-transform duration-300"
              >
                <div
                  className="absolute -top-16 -right-16 w-40 h-40 rounded-full blur-3xl opacity-20 group-hover:opacity-40 transition-opacity"
                  style={{ background: c.color }}
                />
                <div className="mono text-[10px] uppercase tracking-[0.22em] mb-5" style={{ color: c.color }}>
                  {c.overline}
                </div>
                <div
                  className="w-12 h-12 rounded-lg flex items-center justify-center mb-6"
                  style={{ background: `${c.color}1A`, border: `1px solid ${c.color}55` }}
                >
                  <Icon size={22} weight="duotone" style={{ color: c.color }} />
                </div>
                <div className="font-heading text-xl font-semibold mb-3">{c.title}</div>
                <p className="text-sm text-muted leading-relaxed mb-6">{c.body}</p>

                <div className="flex items-center justify-between pt-4 border-t border-ink-text/5">
                  <div
                    className="mono text-xs px-2.5 py-1 rounded-full"
                    style={{
                      background: `${c.color}1A`,
                      color: c.color,
                      border: `1px solid ${c.color}55`,
                    }}
                  >
                    {c.badge}
                  </div>
                  <ArrowUpRight size={18} className="text-muted group-hover:text-brand-cyan transition-colors" />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default UseCases;
